import React from 'react';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import { AutoLoginExternalScene, AutoLoginScene, 
// CheckPasswordScene,
// F2aEmailScene,
// F2aSelectionScene,
// F2aSmsScene,
LoginScene, RestoreErrorScene, RestoreExpiredScene, RestorePasswordScene, } from 'scenes/user';
import { routes, switchRoutes } from 'core/router/router';
const RouterUnloggedRedirect = () => {
    const buCode = React.useMemo(() => { var _a; return (_a = localStorage.getItem('buCode')) !== null && _a !== void 0 ? _a : 'share'; }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Redirect, { to: routes.bu(buCode) })));
};
export const RouterUnlogged = () => {
    const location = useLocation();
    return (React.createElement(Switch, { location: location },
        React.createElement(Route, { path: [switchRoutes.bu] },
            React.createElement(LoginScene, null)),
        React.createElement(Route, { path: [switchRoutes.autologin.base] },
            React.createElement(AutoLoginScene, null)),
        React.createElement(Route, { path: [switchRoutes.autologin.external] },
            React.createElement(AutoLoginExternalScene, null)),
        React.createElement(Route, { path: [switchRoutes.recover.password] },
            React.createElement(RestorePasswordScene, null)),
        React.createElement(Route, { path: [switchRoutes.recover.expired] },
            React.createElement(RestoreExpiredScene, null)),
        React.createElement(Route, { path: [switchRoutes.recover.error] },
            React.createElement(RestoreErrorScene, null)),
        React.createElement(Route, { path: '*' },
            React.createElement(RouterUnloggedRedirect, null))));
};
